import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogFooter,
  DialogTitle,
  DialogDescription,
  DialogClose,
} from "../ui/dialog";
import { Button } from "../ui/button";

const sizeClasses = {
  xs: "sm:max-w-sm",
  sm: "sm:max-w-md",
  md: "sm:max-w-lg",
  lg: "sm:max-w-2xl",
  xl: "sm:max-w-4xl",
  full: "sm:max-w-7xl",
  fullscreen: "w-[95vw] h-[95vh] max-w-none max-h-none",
};


export function ConfirmFormModal({
  isOpen,
  onClose,
  onConfirm,
  title,
  icon,
  iconBackgroundColor = "#E5F3FF", // Default light blue background
  children,
  showHeader = true,
  showFooter = true,
  showCloseButton = true,
  showConfirmButton = true,
  showLeftButton = false,
  confirmButtonText = "OK",
  cancelButtonText = "Cancel",
  leftButtonText = "Left Action",
  confirmButtonVariant = "primary",
  cancelButtonVariant = "outline",
  leftButtonVariant = "secondary",
  confirmButtonSize = "default",
  cancelButtonSize = "default",
  leftButtonSize = "default",
  confirmDisabled = false,
  closeDisabled = false,
  leftButtonDisabled = false,
  onLeftButtonClick,
  size = "md",
  headerClassName,
  bodyClassName,
  footerClassName,
  confirmButtonClassName,
  leftButtonClassName,
  headerStyles,
  bodyStyle,
  footerStyles,
  confirmButtonStyle,
  leftButtonStyle,
}) {
  const dialogMaxW = sizeClasses[size] || sizeClasses.md;

  return (
    <Dialog open={isOpen} onOpenChange={(open) => { if (!open && !closeDisabled) onClose?.(); }}>
      <DialogContent className={`w-full ${dialogMaxW} bg-white !rounded-3xl shadow-lg p-0 border border-[#F0F0F0] ${size === 'fullscreen' ? '!rounded-lg' : ''}`}>
        {showHeader && (
          <DialogHeader
            className={`flex flex-row justify-between items-center px-6 pt-6 ${headerClassName || ""}`}
            style={headerStyles}
          >
            <div className="flex items-center gap-3">
              {icon && (
                <div 
                  className={`flex-shrink-0 w-16 h-16 rounded-xl flex items-center justify-center bg-[${iconBackgroundColor}]`}
                >
                  {icon}
                </div>
              )}
              <DialogTitle className="text-2xl font-semibold text-[#262626]">
                {title}
              </DialogTitle>
            </div>
            {!closeDisabled && (
              <button 
                onClick={onClose}
                className="text-gray-500 hover:text-gray-700 p-1 rounded-sm"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M18 6L6 18M6 6l12 12" />
                </svg>
              </button>
            )}
          </DialogHeader>
        )}
        <div
          className={`px-6 py-4 text-base text-[#262626] overflow-y-auto ${size === 'fullscreen' ? 'max-h-[calc(95vh-120px)]' : 'max-h-[60vh]'} ${bodyClassName || ""}`}
          style={bodyStyle}
        >
          {children}
        </div>
        {showFooter && (
          <DialogFooter
            className={`px-6 py-4 flex items-center !justify-between border-t ${footerClassName || ""}`}
            style={footerStyles}
          >
            {/* Left side button */}
            <div className="flex">
              {showLeftButton && (
                <Button
                  onClick={onLeftButtonClick}
                  variant={leftButtonVariant}
                  size={leftButtonSize}
                  disabled={leftButtonDisabled}
                  className={leftButtonClassName}
                  style={leftButtonStyle}
                >
                  {leftButtonText}
                </Button>
              )}
            </div>
            
            {/* Right side buttons */}
            <div className="flex items-center space-x-3">
              {showCloseButton && (
                <Button 
                  onClick={onClose}
                  variant={cancelButtonVariant}
                  size={cancelButtonSize}
                >
                  {cancelButtonText}
                </Button>
              )}
              
              {showConfirmButton && (
                <Button
                  onClick={onConfirm}
                  variant={confirmButtonVariant}
                  size={confirmButtonSize}
                  disabled={confirmDisabled}
                  className={confirmButtonClassName}
                  style={confirmButtonStyle}
                >
                  {confirmButtonText}
                </Button>
              )}
            </div>
          </DialogFooter>
        )}
      </DialogContent>
    </Dialog>
  );
}
